import { ITheme, mediaQuery } from '@quicktools/shared-components';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    backdrop: {
      display: 'none',
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
      position: 'fixed',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      width: '100%',
      height: '100vh',
      zIndex: 200,

      [mediaQuery(breakpoints.laptop)]: {
        '&.isVisible': {
          display: 'block',
        },
      },
    },
    menuContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: 20,
      padding: [16, 24],
      height: '100%',
      position: 'fixed',
      top: 0,
      width: '100%',
      maxWidth: 256,
      backgroundColor: 'white',
      boxShadow: '0px 0px 16px rgba(0, 0, 0, 0.16)',
      overflowY: 'auto',
    },
    footerImg: {
      marginTop: 'auto',
      marginInline: 'auto',
      width: 46,
      height: 13,
    },
  }),
  {
    name: 'mobile-navigation',
  },
);

export default useStyles;
